import React from 'react';
import { Tabs, Tab, Grid, useTheme } from '@mui/material';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import KingBedIcon from '@mui/icons-material/KingBed';
import KingBedOutlinedIcon from '@mui/icons-material/KingBedOutlined';

import assistLogoBlack from '@shared/assets/assistLogoBlack.svg';
import assistLogoWhite from '@shared/assets/assistLogoWhite.svg';
import { useSelector } from 'react-redux';

const useSelectedColor = (selectedLabel, id) => {
  const theme = useTheme();

  switch (selectedLabel) {
    case 'Vuelos':
      return id === 1 ? '#6FB9DB' : theme.primary;
    case 'Alojamiento':
      return id === 1 ? '#F8A0CA' : theme.primary;
    default:
      return theme.primary;
  }
};

export const TabsBooking = ({ value, setValue }) => {
  const pageConfiguration = useSelector(store => store.pageConfiguration);

  const selectedLabel =
    value === 0 ? 'Vuelos' : value === 1 ? 'Alojamiento' : 'Paquetes';

  const handleChange = (_, newValue) => {
    if (newValue === value) return;
    setValue(newValue);
  };

  const tabSx = {
    width: { xs: '100px', md: '150px' },
    color: '#636466',
    fontWeight: 400,
    '&.Mui-selected': {
      width: { xs: '100px', md: '150px' },
      background: useSelectedColor(selectedLabel, pageConfiguration.id),
      borderRadius: '8px 8px 0px 0px',
      borderBottom: '0px solid #000000',
      color:
        selectedLabel === 'Alojamiento' || selectedLabel === 'Vuelos'
          ? '#fff'
          : '#000',
      fontWeight: 600,
    },
  };

  return (
    <Grid container id="tabRoot" justifyContent="flex-start">
      <Tabs
        value={value}
        textColor="primary"
        onChange={handleChange}
        variant="scrollable"
        scrollButtons={false}
        aria-label="sections"
        sx={{
          minWidth: '100px',
          '& .MuiTabs-indicator': {
            backgroundColor: 'transparent',
          },
        }}
      >
        <Tab icon={<FlightTakeoffIcon />} label="Vuelos" sx={tabSx} />

        <Tab
          icon={value === 1 ? <KingBedIcon /> : <KingBedOutlinedIcon />}
          label="Alojamiento"
          sx={tabSx}
        />

        <Tab
          icon={
            <img
              src={value === 2 ? assistLogoWhite : assistLogoBlack}
              alt="assistLogo"
              style={{ maxHeight: '60px' }}
            />
          }
          sx={tabSx}
        />
      </Tabs>
    </Grid>
  );
};
